import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { InputText } from "primereact/inputtext";
import * as yup from "yup";
import { format } from "date-fns";
import { EmptyPipelineStatus } from "./EmptyPipelineStatus";
import { IPipelineStatus } from "./IPipelineStatus";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
     sub_Status_Name: yup.string().required("Title is required"),
   
});


interface IProps {
    singledata: IPipelineStatus,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
}

export const SubCategoryStatus = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPipelineStatus>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [subCategory, setSubCategory] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IPipelineStatus>({
        resolver: yupResolver(schema),
        defaultValues: props.singledata,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Pipeline_Status_Mast/getSubCategoryTable", "GET", null, `id=${props.singledata.status_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }
    

    const saveToDB = async (body: IPipelineStatus) => {
        console.log(body);
        setLoading(true);
        body = { sub_Status_Name: body.sub_Status_Name, isActive: true, status_ID: props.singledata.status_ID, category_Code: body.category_Code}
        const response = await Fetch("Pipeline_Status_Mast/addSubCategory", "POST", body, null, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            loadTableData();
        } else setLoading(false);
    }

    const onHide = () => {
        props.hideHistory();
        reset(EmptyPipelineStatus);
    }
    const onSubmit = (data: IPipelineStatus) => {
        console.log(data)
        saveToDB(data);
    }

    
    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);


    const toggleVal = async (Sub_Status_ID: number, toggle_type: number) => {
        const response = await Fetch("Pipeline_Status_Mast/togglestatus", "PUT", null, `Sub_Status_ID=${Sub_Status_ID}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            let message: string = "User Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };

    const user_TStatus = (rowData: any) => {
        return (
            <span style={{ color: rowData.isActive ? 'green' : 'red' }} className="cursor-pointer" onClick={() => {  toggleVal(rowData.sub_Status_ID, 1) }}>{rowData.isActive ? "Yes" : "No"}</span>
        );

    };

   
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Sub Category" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
            
                <JVInput column={2} required name="sub_Status_Name" label="Title" control={control}  error={errors.sub_Status_Name?.message} />
                <JVInput column={2} required name="category_Code" label="Code" control={control}  />
                
                <div className="field col-12 md:col-2">
                    <label htmlFor="">&nbsp;</label>
                    <Button label="SUBMIT" type="submit" loading={loading}></Button>
                </div>
            </form>
            <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>

            <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column field="sub_Status_Name" header="Title " style={{maxWidth: "20rem"}} />
                <Column field="category_Code" header="Code" style={{maxWidth: "20rem"}} />
                <Column field="user_Name" header="Created By " style={{maxWidth: "20rem"}} />
                <Column field="created_at" header="Created On" body={(rowData) => <p>{rowData.created_at ? format(new Date(rowData.created_at), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} />
                {/* <Column field="" header="Status " style={{maxWidth: "20rem"}}  body={(rowData) => <span style={{ color: rowData.isActive ? 'green' : 'red' }}>{rowData.isActive ? "Active" : "Inactive"}</span>}  /> */}
                <Column field="" header="Active " style={{maxWidth: "20rem"}}  body={user_TStatus}   />
            </DataTable>
        </Dialog>
    );
}

